import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryRequestModel } from 'src/app/core/models/QueryRequestModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../../admin/admin.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { TableColumns } from '../Shared/TableColumns';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { NzMessageService } from 'ng-zorro-antd/message';
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-responded-query',
  standalone: false,
  templateUrl: './responded-query.component.html',
  styleUrl: './responded-query.component.less'
})
export class RespondedQueryComponent {
  viewGrid = true;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;

  queryDeleteByAdminEnum = QueryStatus.DeletedByRFCAdmin;
  queryDeleteByPartnerEnum = QueryStatus.DeletedByPartner;
  queryResponseEnum = QueryStatus.Responded;
  queryAssgnToDepRepEnum = QueryStatus.AssignedToDeptRep;
  queryRecycledEnum = QueryStatus.Recycled;
  currentUser: User = new User();
  allQueryRequest: QueryRequestModel[] = [];
  filteredQueryRequest: QueryRequestModel[] = [];
  queryReferenceNumber = "";
  Subject = "";
  nonPartnerTableColumns = TableColumns.getFilteredColumns(TableColumns.NON_PARTNER_TABLE_COLUMNS, ['Action','Due Date']);
  partnerTableColumns = TableColumns.getFilteredColumns(TableColumns.PARTNER_TABLE_COLUMNS, ['Action']);
  config: any;
  currentPageSize = 10;
  sortingName: string = "RequestedDate";
  isDesc: boolean = true;

  searchText: string = "";
  exportData: { Title: string; Data: any[]; Headers: string[] }[] = [];

  queryDetail: QueryDetailModel = new QueryDetailModel();

  partnerUserMaster: { item_id: any; item_text: any }[] = [];
  CCSubDepartmentsMaster: { item_id: any; item_text: any }[] = [];
  selectedCCUsers: { item_id: any; item_text: any }[] = [];
  selectedCCSubDepts: { item_id: any; item_text: any }[] = [];
  constructor(private router: Router, public datepipe: DatePipe,
    //private toastrService: ToastrService,
    private userService: UserService,
    private adminService: AdminService,
    private queryService: ClarificationQueryListService,
    public xlxsService: XlsxService,
    private messageService : NzMessageService
  ) { }
  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      
      window.location.href = '/';
    }
    this.queryService.getRespondedQueries(this.currentUser.User_Code ?? 0, 0).subscribe({
      next: (response: any) => {
        this.adminService.getAllRegisteredPartners().subscribe({
          next: (response: any) => {
            if (response.output.length > 0) {
              for (let i = 0; i < response.output.length; i++) {
                this.partnerUserMaster.push({
                  item_id: response.output[i].User_Code,
                  item_text: response.output[i].User_Name
                });
              }
            }
            this.adminService.getAllSubDeptMapping().subscribe({
              next: (response: any) => {
                if (response.output.length > 0) {
                  for (let i = 0; i < response.output.length; i++) {
                    this.CCSubDepartmentsMaster.push({
                      item_id: response.output[i].Sub_Dept_Code,
                      item_text:
                        response.output[i].Department_Name +
                        ' - ' +
                        response.output[i].Sub_Dept_Name
                    });
                  }
                }
              },
              error: (error) => {
                console.error('Error fetching sub-department mapping:', error);
              }
            });
          },
          error: (error) => {
            console.error('Error fetching registered partners:', error);
          }
        });

        this.filteredQueryRequest = this.allQueryRequest = response.output;
        this.config = {
          itemsPerPage: this.currentPageSize,
          currentPage: 1,
          totalItems: 0
        };
      },
      error: (error) => {
        this.messageService.error("Error occurred while fetching all query details", ); 
      }
    });
  }
  pageChanged(event: any) {
    this.config.currentPage = event;
  }

  changePageSize() {
    this.config.itemsPerPage = this.currentPageSize;
  }

  redirectToHomePage() {
    this.router.navigate(['/home']);
  }

  redirectToHome(erroMsg: string) {    
    this.messageService.error(erroMsg, { nzDuration: 3000 });
    this.router.navigate(['/home']);
  }

  redirectBack() {
    this.viewGrid = true;
    this.queryReferenceNumber = "";
    this.Subject = "";
    this.queryDetail = new QueryDetailModel();
  }
  showQueryDetails(queryCode: any, queryDetailCode: any, queryRefNo: any, Subject: any) {
    this.queryReferenceNumber = queryRefNo;
    this.Subject = Subject;
    this.selectedCCUsers = [];
    this.selectedCCSubDepts = [];

    this.queryService.getQueryDetails(queryCode).subscribe({
      next: (response: any) => {
        this.queryDetail = response.output.filter(
          (s: any) => s.Clarification_Query_Detail_Code == queryDetailCode
        )[0];
        this.viewGrid = false;

        if (this.queryDetail.CCUsers) {
          for (let i = 0; i < this.queryDetail.CCUsers.length; i++) {
            const user = this.partnerUserMaster.find(
              (s) => s["item_id"] == this.queryDetail.CCUsers[i]
            );
            if (user) {
              this.selectedCCUsers.push(user["item_text"]);
            }
          }
        }

        if (this.queryDetail.CCSubDepartments) {
          for (let i = 0; i < this.queryDetail.CCSubDepartments.length; i++) {
            const subDept = this.CCSubDepartmentsMaster.find(
              (s) => s["item_id"] == this.queryDetail.CCSubDepartments[i]
            );
            if (subDept) {
              this.selectedCCSubDepts.push(subDept["item_text"]);
            }
          }
        }
      },
      error: (error) => {
        this.redirectToHome(
          error.status == 404
            ? "You are not authorized to view the selected Query Details."
            : "Error occurred while fetching the query details"
        );
      },
    });
  }

  searchQuery() {
    if (this.searchText.length > 2) {
      this.filteredQueryRequest = this.allQueryRequest.filter(item => item.QueryRequestNumber.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || (this.currentUser.Is_Partner ? item.PartnerQueryStatus : item.QueryStatus).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.RequestorName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.RequestedDateInString.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.Category.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.SubCategory.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.CompanyName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.Block.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.PriorityLevel.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.Confidential.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.Department.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.SubDeptartment.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.RespondedDateInString.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || item.CreatedByUserName.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        || (item.Subject == null ? '' : item.Subject.toLowerCase()).indexOf(this.searchText.toLowerCase()) !== -1);
    }
    else if (this.searchText.length <= 2) {
      this.filteredQueryRequest = this.allQueryRequest;
    }
    this.config.currentPage = 1;
  }
  exportToExcel() {
    this.exportData = [];
    let currentDate = new Date();
    let exportData = [];
    let headers = ["Reference Number",
      "Request Status",
      "Requestor Name",
      "Company",
      "Block",
      "Request Date",
      "Priority",
      "Confidential",
      "Department",
      "Sub Deptartment",
      "Request Completion Date",
      "Request Created By"
    ];

    exportData = this.filteredQueryRequest.map(function (item) {
      return {
        "Reference Number": item.QueryRequestNumber,
        "Request Status": item.QueryStatus,
        "Requestor Name": item.RequestorName,
        "Company": item.CompanyName,
        "Block": item.Block,
        "Request Date": item.RequestedDate,
        "Priority": item.PriorityLevel,
        "Confidential": item.Confidential,
        "Department": item.Department,
        "Sub Deptartment": item.SubDeptartment,
        "Request Completion Date": item.RespondedDate,
        "Request Created By": item.CreatedByUserName
      };
    });

    this.exportData.push({ Title: 'Responded-Query', Data: exportData, Headers: headers });
    this.xlxsService.export(this.exportData, "Responded-Query_" + this.datepipe.transform(currentDate, 'dd-MMM-yyyy'));
  }
  sort(name: string): void {
    if (name && this.sortingName !== name) {
      this.isDesc = false;
    } else {
      this.isDesc = !this.isDesc;
    }
    this.sortingName = name;
  }

  resetPagination() {
    this.config.currentPage = 1;
  }
  searchQueryByKeyword() {
    this.searchText = this.searchText.trim();
    //this.spinnerService.Spinner("show");

    if (this.searchText.length > 2) {
      this.filteredQueryRequest = this.allQueryRequest.filter(item =>
        JSON.stringify(Object.values(item)) //to check only value, if not used then will compare with column name also 
          .toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
    }
    else if (this.searchText.length <= 2) {
      this.filteredQueryRequest = this.allQueryRequest;
    }
    this.resetPagination();
    //this.spinnerService.Spinner("hide");  
  }

  resetFilter() {
    if (this.searchText.length == 0) { this.filteredQueryRequest = this.allQueryRequest };
  }
  exportAsPDF() {
    const documentDefinition = { content: 'This is an sample PDF printed with pdfMake' };

    if (this.currentUser.Is_Partner) {
      pdfMake.createPdf(this.getdocDefinition()).download(this.queryDetail.Query_Reference_Number + '.pdf');
    }
    else {
      pdfMake.createPdf(this.getDocumentDefinition()).download(this.queryDetail.Query_Reference_Number + '.pdf');
    }

  }
  getdocDefinition(): TDocumentDefinitions {
    return {
      content: [
        {
          text: 'Query Reference Number - ' + this.queryDetail.Query_Reference_Number,
          style: 'header'
        },
        {
          text: 'Requestor Details',
          style: 'tableheader'
        },
        {
          text: 'Requestor Name - ' + this.queryDetail.RequestorName,
          style: 'label'
        },
        {
          text: 'Query Detail',
          style: 'tableheader'
        },
        this.getQueryDetails(),
        {
          text: 'Clarification Request Details',
          style: 'tableheader'
        },
        this.getQueryRequestDetails(),
        {
          text: 'Query Resolution Details',
          style: 'tableheader'
        },


        { text: 'Resolution Comments', style: 'tab' },
        {
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.queryDetail.Resolution_Comment, style: 'value' }]
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        tableheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 10],
          decoration: 'underline'
        },
        tab: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
          decoration: 'underline'
        },
        name: {
          fontSize: 12,
          bold: true
        },
        label: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
        },
        value: {
          fontSize: 10,
          //italics: true,
          margin: [3, 3, 3, 3],
        },
      }
    };

  }
  getDocumentDefinition(): TDocumentDefinitions {
    return {
      content: [
        {
          text: 'Query Reference Number - ' + this.queryDetail.Query_Reference_Number,
          style: 'header'
        },
        {
          text: 'Requestor Details',
          style: 'tableheader'
        },
        {
          text: 'Requestor Name - ' + this.queryDetail.RequestorName,
          style: 'label'
        },
        {
          text: 'Query Detail',
          style: 'tableheader'
        },
        this.getQueryDetails(),
        {
          text: 'Clarification Request Details',
          style: 'tableheader'
        },
        this.getQueryRequestDetails(),
        {
          text: 'Query Resolution Details',
          style: 'tableheader'
        },
        {
          text: 'Consolidated Comments',
          style: 'tab'
        },
        {
          table: {
            headerRows: 1,            
            widths: ['*', 'auto', 'auto'],
            body: [
              [{ text: 'Commented By', style: 'label' }, { text: 'Comment', style: 'label' }, { text: 'Commented Date', style: 'label' }],              
              ...this.queryDetail.ConsolidatedComment.map((p:any) => ([
                { text: p["CommentedBy"], style: 'value' },
                { text: p["Comment"], style: 'value' },
                { text: p["CommentedDate"], style: 'value' }])),
            ]
          }
        },
        { text: 'Resolution Comments', style: 'tab' },
        {
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.queryDetail.Resolution_Comment, style: 'value' }]
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        tableheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 10],
          decoration: 'underline'
        },
        tab: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
          decoration: 'underline'
        },
        name: {
          fontSize: 12,
          bold: true
        },
        label: {
          fontSize: 10,
          bold: true,
          margin: [3, 3, 3, 3],
        },
        value: {
          fontSize: 10,
          //italics: true,
          margin: [3, 3, 3, 3],
        },
      }
    };
  }
  getQueryDetails() {
    return {
      table: {
        widths: ['*', '*'],
        body: [
          [{ text: 'Date of Request', style: 'label' }, { text: this.queryDetail.RequestDate, style: 'value' }],
          [{ text: 'Completion Date', style: 'label' }, { text: this.queryDetail.CompletionDate, style: 'value' }],
          [{ text: 'Subject', style: 'label' }, { text: this.Subject, style: 'value' }],
          [{ text: 'Priority Level', style: 'label' }, { text: this.queryDetail.PriorityLevel, style: 'value' }],
          [{ text: 'Confidential', style: 'label' }, { text: (this.queryDetail.Is_Confidential ? "Yes" : "No"), style: 'value' }],
          [{ text: 'CC Emails', style: 'label' }, { text: this.queryDetail.CCEmails, style: 'value' }],
        ]
      }
    };
  }

  getQueryRequestDetails() {
    if (this.currentUser.Is_Partner) {
      return {
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: 'Block', style: 'label' }, { text: this.queryDetail.Block, style: 'value' }],
            [{ text: 'Company', style: 'label' }, { text: this.queryDetail.CompanyName, style: 'value' }],
            [{ text: 'Department', style: 'label' }, { text: this.queryDetail.Department, style: 'value' }],
            [{ text: 'Sub Department', style: 'label' }, { text: this.queryDetail.SubDepartment, style: 'value' }],
            [{ text: 'CC', style: 'label' }, { text: this.selectedCCUsers.join(', '), style: 'value' }],
            [{ text: 'Partner Comments', style: 'label' }, { text: this.queryDetail.Partner_Comment, style: 'value' }]
          ]
        }
      };
    }
    else {
      return {
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: 'Block', style: 'label' }, { text: this.queryDetail.Block, style: 'value' }],
            [{ text: 'Company', style: 'label' }, { text: this.queryDetail.CompanyName, style: 'value' }],
            [{ text: 'Department', style: 'label' }, { text: this.queryDetail.Department, style: 'value' }],
            [{ text: 'Sub Department', style: 'label' }, { text: this.queryDetail.SubDepartment, style: 'value' }],
            [{ text: 'CC Sub Department', style: 'label' }, { text: this.selectedCCSubDepts.join(', '), style: 'value' }],
            [{ text: 'CC', style: 'label' }, { text: this.selectedCCUsers.join(', '), style: 'value' }],
            [{ text: 'Company Restricted', style: 'label' }, { text: (this.queryDetail.Company_Restricted ? "Yes" : "No"), style: 'value' }],
            [{ text: 'Partner Comments', style: 'label' }, { text: this.queryDetail.Partner_Comment, style: 'value' }],
            [{ text: 'Query Category', style: 'label' }, { text: this.queryDetail.Category, style: 'value' }],
            [{ text: 'Query Sub Category', style: 'label' }, { text: this.queryDetail.SubCategory, style: 'value' }],
            [{ text: 'Letter Reference Number', style: 'label' }, { text: this.queryDetail.LetterReference_Number, style: 'value' }],
            [{ text: 'Contract Number', style: 'label' }, { text: this.queryDetail.Contract_Number, style: 'value' }],
            [{ text: 'AFE Number', style: 'label' }, { text: this.queryDetail.AFE_Number, style: 'value' }],
            [{ text: 'Work Order Number', style: 'label' }, { text: this.queryDetail.Work_Order_Number, style: 'value' }],
            [{ text: 'Category Comment', style: 'label' }, { text: this.queryDetail.Category_Comments, style: 'value' }],
          ]
        }
      };
    }

  }
}
